import { render, staticRenderFns } from "./InvestBanner.vue?vue&type=template&id=d705745c&scoped=true&"
import script from "./InvestBanner.vue?vue&type=script&lang=js&"
export * from "./InvestBanner.vue?vue&type=script&lang=js&"
import style0 from "./InvestBanner.vue?vue&type=style&index=0&id=d705745c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d705745c",
  null
  
)

export default component.exports